// extracted by mini-css-extract-plugin
export var fullWidthCTA = "FullWidthCTA-module--fullWidthCTA--fd81b";
export var fullWidthCTA___withBackground = "FullWidthCTA-module--fullWidthCTA___withBackground--a6a52";
export var fullWidthCTA__container = "FullWidthCTA-module--fullWidthCTA__container--c44ee";
export var fullWidthCTA__icon = "FullWidthCTA-module--fullWidthCTA__icon--49238";
export var fullWidthCTA__inner = "FullWidthCTA-module--fullWidthCTA__inner--4b019";
export var fullWidthCTA__text = "FullWidthCTA-module--fullWidthCTA__text--ee91c";